import { attendance, IUpdateStatus, dataStatus } from "./utils";
import { ISelectOptions } from "@/utils/models/core";

import { useState } from "react";
import Button from "@/components/common/Button/Button";
import { useTsRestQueryClient } from "@ts-rest/react-query";
import { opusClient } from "@/utils/rest-client/opus-client";
import useAuth from "@/hooks/useAuth";
import { addMinutes } from "date-fns";
import { ButtonStatus } from "./ButtonStatus";
import { UserActivity } from "@/utils/validators/user-status.validator";

const UpdateStatus = ({ setStatusOpen }: IUpdateStatus) => {
	const { user, getUsers, getMe } = useAuth();

	const apiQueryClient = useTsRestQueryClient(opusClient);

	const { mutate: mutateUserStatus } =
		apiQueryClient.users.updateUserStatus.useMutation();

	const [status, setStatus] = useState<string>(
		user!.userStatus!.status as string
	);
	const [activity, setActivity] = useState<string>(
		user!.userStatus!.activity as string
	);
	const handleUpdateStatus = () => {
		if (status) {
			mutateUserStatus(
				{
					params: { userId: user!.id },
					body: {
						until: addMinutes(new Date(), 30).toISOString(),
						status,
						activity: activity as UserActivity,
					},
				},
				{
					onSuccess: async () => {
						await setStatusOpen(false);
						getUsers();
						getMe();
					},
					onSettled: () => {
						setStatusOpen(false);
					},
				}
			);
		}
	};

	return (
		<div>
			<div>
				<h2 className="text-lg font-bold mb-5">
					What is your attendance/status?
				</h2>

				<div className="mb-5">
					<h3 className="text-md font-bold mb-2">Attendance</h3>
					<div className="space-y-2">
						{attendance.map((item: ISelectOptions, index: number) => (
							<ButtonStatus
								setStatus={setStatus}
								status={status}
								index={index}
								item={item}
								setActivity={setActivity}
								activity={activity}
							/>
						))}
					</div>
				</div>
				<div className="mb-5">
					<h3 className="text-md font-bold mb-2">Attendance</h3>
					<div className="space-y-2">
						{dataStatus.map((item: ISelectOptions, index: number) => {
							let shouldRender = false;

							if (user?.userStatus?.status === "clocked-in") {
								shouldRender =
									item.value === "unavailable" || item.value === "on-break";
							} else if (user?.userStatus?.status === "unavailable") {
								shouldRender =
									item.value === "clocked-in" || item.value === "on-break";
							} else if (user?.userStatus?.status === "on-break") {
								shouldRender =
									item.value === "clocked-in" || item.value === "on-break";
							} else if (
								user?.userStatus?.status === "vacation-leave" ||
								user?.userStatus?.status === "sick-leave" ||
								user?.userStatus?.status === "carers-leave"
							) {
								shouldRender =
									item.value === "clocked-in" || item.value === "on-break";
							} else {
								shouldRender =
									item.value === "unavailable" || item.value === "on-break";
							}
							return shouldRender ? (
								<ButtonStatus
									key={index}
									setStatus={setStatus}
									status={status}
									index={index}
									item={item}
									setActivity={setActivity}
									activity={activity}
								/>
							) : null;
						})}
					</div>
				</div>
				<div className="flex justify-end items-end space-x-2">
					<Button
						variant="white"
						className="border"
						classNameButton="!w-36"
						rounded="full"
						onClick={() => setStatusOpen(false)}>
						Cancel
					</Button>
					<Button
						className="border bg-opus-blue-100"
						classNameButton="!w-36"
						rounded="full"
						onClick={handleUpdateStatus}>
						Save
					</Button>
				</div>
			</div>
		</div>
	);
};

export default UpdateStatus;
